import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=0466fe10&"
import script from "./edit-product.vue?vue&type=script&lang=js&"
export * from "./edit-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports